require('./bootstrap');
require('./Base64/Base64');
// require('@ckeditor/ckeditor5-build-classic')

/////////////////////////////////////////
// Theme - copied from ./dashkit/theme.js

import './dashkit/autosize';
import './dashkit/bootstrap';
import './dashkit/chart';
import './dashkit/checklist';
import './dashkit/choices';
import './dashkit/dropzone';
import './dashkit/flatpickr';
import './dashkit/highlight';
import './dashkit/inputmask';
import './dashkit/kanban';
import './dashkit/list';
import './dashkit/map';
import './dashkit/navbar-collapse';
import './dashkit/navbar-dropdown';
import './dashkit/popover';
import './dashkit/tooltip';
import './dashkit/quill';
import './dashkit/wizard';

// User
import './dashkit/user';

import '../website/landkit/bigpicture';

import { createApp } from 'vue';

// import CKEditor from '@ckeditor/ckeditor5-vue';

import AdminDeliverableCreativeAsset from './components/Admin/AdminDeliverableCreativeAsset.vue';
import AdminPerformance from './components/Admin/AdminPerformance.vue';
import AdminUploadAdMediaForm from './components/Admin/AdminUploadAdMediaForm.vue';
import StudioUploadAdMediaForm from './components/Admin/StudioUploadAdMediaForm.vue';

import ClientDeliverableCreativeAsset from './components/Client/ClientDeliverableCreativeAsset.vue';
import CreatorReviewFlow from './components/Client/CreatorReviewFlow.vue';
import CreatorFeedback from './components/Client/CreatorFeedback.vue';

import AgencyCreatorCreativeAssetUpload from './components/Agency/AgencyCreatorCreativeAssetUpload.vue';
import AgencyCreativeAssetForm from './components/Agency/AgencyCreativeAssetForm.vue';

// import CreatorDeliverable from './components/Creator/CreatorDeliverable.vue';
import CreatorUploadCreativeAssetForm from './components/Creator/CreatorUploadCreativeAssetForm.vue';
import CreatorDeliverableCreativeAsset from './components/Creator/CreatorDeliverableCreativeAsset.vue';

import ButtonToggleApproved from './components/ButtonToggleApproved.vue';
import ButtonCopyToClipboard from './components/ButtonCopyToClipboard.vue';

if(document.getElementById('adminVue'))
{
	const adminApp = createApp({
		components: {
			AdminDeliverableCreativeAsset,
			AdminUploadAdMediaForm,
			AdminPerformance,
			StudioUploadAdMediaForm,
			ButtonCopyToClipboard
		}
	});

	adminApp.mount('#adminVue');

	$(document).ready(function() {
		const tooltips = document.querySelectorAll('[data-bs-toggle="tooltip"]');

		tooltips.forEach(tooltip => {
			new Tooltip(tooltip);
		});
	})
}

if(document.getElementById('creatorVue'))
{
	const creatorApp = createApp({
		components: {
			CreatorUploadCreativeAssetForm,
			CreatorDeliverableCreativeAsset,
		}
	});
	creatorApp.mount('#creatorVue');
}

if(document.getElementById('clientVue'))
{
	const clientApp = createApp({
		components: {
			ClientDeliverableCreativeAsset,
			CreatorFeedback,
			ButtonToggleApproved,
			CreatorReviewFlow,
		}
	});
	clientApp.mount('#clientVue');
}

if(document.getElementById('clientCreatorFeedbackVue'))
{
	const clientCreatorFeedbackApp = createApp({
		components: {
			CreatorFeedback,
		}
	});
	clientCreatorFeedbackApp.mount('#clientCreatorFeedbackVue');
}

if(document.getElementById('adminCreatorFeedbackVue'))
{
	const adminCreatorFeedbackApp = createApp({
		components: {
			CreatorFeedback,
		}
	});
	adminCreatorFeedbackApp.mount('#adminCreatorFeedbackVue');
}

if(document.getElementById('agencyVue'))
{
	const agencyApp = createApp({
		components: {
			AgencyCreativeAssetForm,
		}
	});
	agencyApp.mount('#agencyVue');
}

if(document.getElementById('agencyCreatorVue'))
{
	const agencyCreatorApp = createApp({
		components: {
			AgencyCreatorCreativeAssetUpload,
		}
	});
	agencyCreatorApp.mount('#agencyCreatorVue');
}
